// global.ts
import { Injectable } from "@angular/core";
import { AppConfig } from "./service/app.config";
import * as moment from "moment";
@Injectable()
export class Global {
    apiUrl = AppConfig.settings.apiServer.apiUrl;
    TOKEN_PUBLIC = AppConfig.settings.apiServer.tokenPublic;
    currentUser: any = {}
    token_acesso: any;


    dateFormat(dataStr) {
        if (dataStr == null || dataStr == "") {
            return "--/--/--";
        }

        return moment(dataStr).format("DD/MM/YYYY");
    }

    /* calculando o md5 */

    formatApiPath(items: any = []) {
        let returnStr = "";
        items.forEach(element => {
            returnStr += element + "/";
        });
        return returnStr.substring(0, returnStr.length - 1);
    }

    creditCardType(cc: string) {
        let amex = new RegExp('^3[47][0-9]{13}$');
        let visa = new RegExp('^4[0-9]{12}(?:[0-9]{3})?$');
        let cup1 = new RegExp('^62[0-9]{14}[0-9]*$');
        let cup2 = new RegExp('^81[0-9]{14}[0-9]*$');

        let mastercard = new RegExp('^5[1-5][0-9]{14}$');
        let mastercard2 = new RegExp('^2[2-7][0-9]{14}$');

        let disco1 = new RegExp('^6011[0-9]{12}[0-9]*$');
        let disco2 = new RegExp('^62[24568][0-9]{13}[0-9]*$');
        let disco3 = new RegExp('^6[45][0-9]{14}[0-9]*$');

        let diners = new RegExp('^3[0689][0-9]{12}[0-9]*$');
        let jcb = new RegExp('^35[0-9]{14}[0-9]*$');


        if (visa.test(cc)) {
            return 'VISA';
        }
        if (amex.test(cc)) {
            return 'AMEX';
        }
        if (mastercard.test(cc) || mastercard2.test(cc)) {
            return 'MASTERCARD';
        }
        if (disco1.test(cc) || disco2.test(cc) || disco3.test(cc)) {
            return 'DISCOVER';
        }
        if (diners.test(cc)) {
            return 'DINERS';
        }
        if (jcb.test(cc)) {
            return 'JCB';
        }
        if (cup1.test(cc) || cup2.test(cc)) {
            return 'CHINA_UNION_PAY';
        }
        return undefined;
    }


    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    mascara(t, mask) {
        var i = t.currentTarget.value;
        var saida = mask.substring(1, 0);
        var texto = mask.substring(i)
        if (texto.substring(0, 1) != saida) {
            t.currentTarget.value += texto.substring(0, 1);
        }
    }


    formatDateDay(value) {
        if (value) {
            return moment(value).format("DD");
        }
        return "--";
    }
    formatDateDayMonth(value) {
        if (value) {
            return moment(value).format("DD/MM");
        }
        return "--";
    }

    formatDateYear(value) {
        if (value) {
            return moment(value).format("YYYY");
        }
        return "--";
    }

    formateDateMonth(value) {
        var meses = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
        if (value) {
            var monthIndex = moment(value).month();
            return meses[monthIndex];
        }
        return "--";
    }

    formateDate(value) {
        if (value) {
            return moment(value).format("DD/MM/YYYY");
        }
        return "--";
    }

    formateDateAndTime(value) {
        if (value) {
            return moment(value).format("DD/MM/YYYY HH:MM");
        }
        return "--";
    }

    formateDateDayWeek(value) {
        var week = ["Domingo", "Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado"]
        if (value) {
            var weekIndex = moment(value).day();
            return week[weekIndex];
        }
        return "--";
    }

    formateDateDayWeekEn(value) {
        var week = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
        if (value) {
            var weekIndex = moment(value).day();
            return week[weekIndex];
        }
        return "--";
    }

    formateDateMonthEn(value) {
        var meses = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        if (value) {
            var monthIndex = moment(value).month();
            return meses[monthIndex];
        }
        return "--";
    }

    formateTime(value) {
        if (value) {
            return moment(value).format("HH:mm");
        }
        return "--";
    }

    formaterCurrency(value) {
        if (value) {
            if (value.toString().includes("R$")) {
                return value.replace("R$", "").trim();
            }
            return value;
        }
        return value
    }

    formatDate(value) {
        if (value) {
            var week = this.formateDateDayWeek(value);
            var day = this.formatDateDay(value);
            var month = this.formateDateMonth(value);
            var year = this.formatDateYear(value);
            return `${week} , ${day} de ${month} de ${year}`;
        }
    }

    formatDateEn(value) {
        if (value) {
            var week = this.formateDateDayWeekEn(value);
            var day = this.formatDateDay(value);
            var month = this.formateDateMonthEn(value);
            var year = this.formatDateYear(value);
            return `${week} , ${month} ${day}, ${year}`;
        }
    }


    MD5(d) {
        var result = this.M(this.V(this.Y(this.X(d), 8 * d.length)));
        return result.toLowerCase()
    };

    M(d) {
        for (var _, m = "0123456789ABCDEF", f = "", r = 0; r < d.length; r++)_ = d.charCodeAt(r), f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _);
        return f;
    }

    X(d) {
        for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++)_[m] = 0;
        for (m = 0; m < 8 * d.length; m += 8)_[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32;
        return _;
    }

    V(d) {
        for (var _ = "", m = 0; m < 32 * d.length; m += 8)_ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255);
        return _;
    }

    Y(d, _) {
        d[_ >> 5] |= 128 << _ % 32, d[14 + (_ + 64 >>> 9 << 4)] = _;
        for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) {
            var h = m, t = f, g = r, e = i;
            f = this.md5_ii(f = this.md5_ii(f = this.md5_ii(f = this.md5_ii(f = this.md5_hh(f = this.md5_hh(f = this.md5_hh(f = this.md5_hh(f = this.md5_gg(f = this.md5_gg(f = this.md5_gg(f = this.md5_gg(f = this.md5_ff(f = this.md5_ff(f = this.md5_ff(f = this.md5_ff(f, r = this.md5_ff(r, i = this.md5_ff(i, m = this.md5_ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = this.md5_ff(r, i = this.md5_ff(i, m = this.md5_ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = this.md5_ff(r, i = this.md5_ff(i, m = this.md5_ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = this.md5_ff(r, i = this.md5_ff(i, m = this.md5_ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = this.md5_gg(r, i = this.md5_gg(i, m = this.md5_gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = this.md5_gg(r, i = this.md5_gg(i, m = this.md5_gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = this.md5_gg(r, i = this.md5_gg(i, m = this.md5_gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = this.md5_gg(r, i = this.md5_gg(i, m = this.md5_gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = this.md5_hh(r, i = this.md5_hh(i, m = this.md5_hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = this.md5_hh(r, i = this.md5_hh(i, m = this.md5_hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = this.md5_hh(r, i = this.md5_hh(i, m = this.md5_hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = this.md5_hh(r, i = this.md5_hh(i, m = this.md5_hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = this.md5_ii(r, i = this.md5_ii(i, m = this.md5_ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = this.md5_ii(r, i = this.md5_ii(i, m = this.md5_ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = this.md5_ii(r, i = this.md5_ii(i, m = this.md5_ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = this.md5_ii(r, i = this.md5_ii(i, m = this.md5_ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551), m = this.safe_add(m, h), f = this.safe_add(f, t), r = this.safe_add(r, g), i = this.safe_add(i, e)
        }
        return Array(m, f, r, i)
    };

    md5_cmn(d, _, m, f, r, i) {
        return this.safe_add(this.bit_rol(this.safe_add(this.safe_add(_, d), this.safe_add(f, i)), r), m)
    };

    md5_ff(d, _, m, f, r, i, n) {
        return this.md5_cmn(_ & m | ~_ & f, d, _, r, i, n)
    };

    md5_gg(d, _, m, f, r, i, n) {
        return this.md5_cmn(_ & f | m & ~f, d, _, r, i, n)
    };

    md5_hh(d, _, m, f, r, i, n) {
        return this.md5_cmn(_ ^ m ^ f, d, _, r, i, n)
    };

    md5_ii(d, _, m, f, r, i, n) {
        return this.md5_cmn(m ^ (_ | ~f), d, _, r, i, n)
    };

    safe_add(d, _) {
        var m = (65535 & d) + (65535 & _);
        return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m
    };

    bit_rol(d, _) {
        return d << _ | d >>> 32 - _
    };

    /* necessário para o md5 */
    /** NORMAL words**/
    md5Normal(valor) {
        //value = 'test';
        var result = this.MD5(valor);
        //document.body.innerHTML = 'hash -  normal words: ' + result;
        return result;
        // value = 'מבחן'
    }


    /** NON ENGLISH words**/
    md5English(value) {
        //unescape() can be deprecated for the new browser versions
        //var result = this.MD5(unescape(encodeURIComponent(value)));
        //document.body.innerHTML += '<br><br>hash - non english words: ' + result;
        //return result;
    }

    /* fim das variaveis para md5 */

}
